import { scrollToElementWithOffset } from '@/utils/scrollToElementWithOffset';

export const scrollToWebformHeader = () => {
  const webformHeader = document.querySelector('.webform-body') as HTMLElement;

  if (webformHeader) {
    scrollToElementWithOffset(webformHeader, 120);
  }
};
